"use strict";

angular.module("core")
.controller("PartnershipsFinancialPaymentMethodsConfirmationController", function(
    $rootScope, $scope, $attrs, close, PaymentService
) {
    var _this = this;

    $scope.message = $attrs.message;
    $scope.selectedInstances = $attrs.selectedInstances;
    $scope.text = $attrs.text;
    $scope.methodChoicesLocalized = [];
    $scope.data = {
        allowed_payment_methods: []
    }

    PaymentService.getVendorAllowedPaymentMethodChoicesLocalized()
    .then(function onSuccess(response) {
        $scope.methodChoicesLocalized = response.data;
        $scope.data.allowed_payment_methods = Object.keys($scope.methodChoicesLocalized);
    });

    this.close = function(confirm) {
        $scope.$element.modal("hide");
        $scope.$element.remove();
        if (confirm) {
            close.apply(this, arguments);
        }
    };

    this.submit = function() {
        $scope.$element.modal("hide");
        $scope.$element.remove();
        var modalFormData = {
            selectedInstances: $scope.selectedInstances,
            allowed_payment_methods: $scope.data.allowed_payment_methods
        };
        close.apply(this, [modalFormData]);
    };
});



//////////////////
// WEBPACK FOOTER
// ./vendor/app-core/action-modal/partnership-financial-payment-methods-confirmation.modal.js
// module id = 907
// module chunks = 0